import ShippingsPage from '@/components/pages/admin/shippings/Shippings';
import ShippingCreate from '@/components/pages/admin/shippings/ShippingCreate';

const shippingsRoutes = [
    {
        path: '/admin/bons-de-transport/nouveau',
        name: 'shippings-create',
        meta: {
            title: 'shippings',
            icon: 'shipping',
            roles: ['ROLE_STORE_SELLER', 'ROLE_BRAND_STORE', 'ROLE_ADMIN'],
            cms: ['FAUME', 'SHOPIFY'],
            clients: [10, 30, 46, 52]
        },
        component: ShippingCreate
    },
    {
        path: '/admin/bons-de-transport',
        name: 'shippings',
        meta: {
            title: 'shippings',
            icon: 'shipping',
            roles: ['ROLE_STORE_SELLER', 'ROLE_BRAND_STORE', 'ROLE_ADMIN'],
            cms: ['FAUME', 'SHOPIFY'],
            clients: [10, 30, 46, 52]
        },
        component: ShippingsPage
    },
    {
        path: '/admin/bons-de-transport/*',
        redirect: {
            name: 'shippings'
        }
    }
];

export default shippingsRoutes;
